/**
 * Mesh data types for Rune models
 * Auto-generated - do not edit manually
 */

import type { ExtractedMaterial } from "../types.js";

export interface RuneMesh {
  name: string;
  positions: Float32Array;
  indices: Uint16Array | Uint32Array;
  normals: Float32Array;
  uvs?: Float32Array;
  /** Index into variant's materials array */
  materialIndex?: number;
}

/** Extracted materials from the original Rune model */
export type RuneMaterials = ExtractedMaterial[];

/**
 * All available rune variants
 */
export type RuneVariant =
  | "air"
  | "astral"
  | "blood"
  | "body"
  | "chaos"
  | "cosmic"
  | "death"
  | "dust"
  | "earth"
  | "fire"
  | "lava"
  | "law"
  | "mind"
  | "mist"
  | "mud"
  | "nature"
  | "smoke"
  | "soul"
  | "steam"
  | "water"
  | "wrath";

export const RUNE_VARIANTS: RuneVariant[] = [
  "air",
  "astral",
  "blood",
  "body",
  "chaos",
  "cosmic",
  "death",
  "dust",
  "earth",
  "fire",
  "lava",
  "law",
  "mind",
  "mist",
  "mud",
  "nature",
  "smoke",
  "soul",
  "steam",
  "water",
  "wrath",
];
